import { Component, Input } from '@angular/core';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { CultivationGuideComponent } from '../../cultivation-guide/cultivation-guide.component';
import { Plant } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@entities/app/plant.entity';
import { CommonModule } from '@angular/common';
import {
  CultivationResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/cultivation/cultivation.response';
import {
  CultivationListResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/cultivation/cultivation-list.response';
import {
  CultivationVariantResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/cultivation/cultivation-variant.response';
import {
  CultivationVariantListResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/cultivation/cultivation-variant-list.response';

@Component({
  selector: 'vw-cultivation-guide-toast',
  imports: [
    SharedModule,
    CultivationGuideComponent,
    CommonModule
  ],
  templateUrl: './cultivation-guide-toast.component.html',
  styleUrl: './cultivation-guide-toast.component.scss'
})
export class CultivationGuideToastComponent extends BaseToastComponent {
  @Input() plant: Plant = null;
  @Input() cultivationVariant: CultivationVariantResponse | CultivationVariantListResponse;
  @Input() cultivation: CultivationResponse | CultivationListResponse;

  constructor() {
    super();
  }


}
